import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { forwardRef, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputPESELProps {
    isRequired: boolean;
    initValue?: string;
}

const InputPESEL = forwardRef((props: InputPESELProps, ref) => {

    const [numberPESEL, setNumberPESEL] = useState<string>(props.initValue ?? "");
    const [numberPESELError, setNumberPESELError] = useState<string>("");
    const validateNumberPESEL = () => {
        if (props.isRequired && !numberPESEL) {
            setNumberPESELError("Numer PESEL jest wymagany");
            return false;
        } else if (!/^\d{11}$/.test(numberPESEL)) {
            setNumberPESELError("Niepoprawny numer PESEL");
            return false;
        } else {
            setNumberPESELError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateNumberPESEL(),
        value() { return numberPESEL; }
    }));

    return (
        <FormControl isInvalid={!!numberPESELError}
            mt="5"
        >
            <FormLabel>Numer PESEL {props.isRequired && <RequiredMark />}</FormLabel>
            <Input
                maxLength={11}
                max={11}
                type="text"
                placeholder="RRMMDDPPPPK"
                value={numberPESEL}
                onChange={(e) => setNumberPESEL(e.target.value)}
                onBlur={validateNumberPESEL}
            />
            <FormErrorMessage>{numberPESELError}</FormErrorMessage>
        </FormControl>
    );
});

export default InputPESEL;